import React from 'react';

function Footer() {
  return (
    <footer className="attribution">
      Challenge by{' '}
      <a href="https://www.frontendmentor.io?ref=challenge" target="_blank" rel="noreferrer">
        Frontend Mentor
      </a>
      . Coded by <a href="https://github.com/Yemisrach15">Yemisrach15</a>.
    </footer>
  );
}

export default Footer;
